module.exports = __webpack_public_path__ + "static/img/12.ba0e21f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/zh/12.png
// module id = KJhm
// module chunks = 0